//-------------------------------------------------------------------------------------------------- Imports
import { Button, Card, Col, Row, Typography } from "antd";
import { RightOutlined } from "@ant-design/icons";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { StyleSheet } from "../../StyleSheet";
import SubDefaultLayout from "../../components/SubDefaultLayout";
import Loading from "../../components/Loading";
import { AppDispatch } from "../../stores/store";
import { getInternetSeguroAccount } from "../../stores/slices/internetSeguroSlice";
import {
  InternetSeguroUser,
  ResponseInternetSeguroAccountDetail,
} from "../../types/common";
const { Text } = Typography;

//-------------------------------------------------------------------------------------------------- View
const ParentalControlUsers = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const account = useSelector(
    (state: any) =>
      state.internetSeguro
        .account as ResponseInternetSeguroAccountDetail | null,
  );
  const accountLoaded = useSelector(
    (state: any) => state.internetSeguro.accountLoaded,
  );
  const users: InternetSeguroUser[] = account?.users ?? [];

  useEffect(() => {
    if (!accountLoaded) {
      dispatch(getInternetSeguroAccount());
    }
  }, [dispatch, accountLoaded]);

  if (!accountLoaded) {
    return <Loading />;
  }

  return (
    <SubDefaultLayout
      title={"Usuarios"}
      needReturn={true}
      navigateTo="/parental-control"
    >
      <div style={styles.listContainer}>
        {users.length === 0 ? (
          <Text style={styles.emptyText}>
            Aún no hay usuarios registrados
          </Text>
        ) : (
          users.map((user, index) => (
            <Card
              key={user.userId || index}
              style={styles.cardStyles}
              onClick={() =>
                navigate(`/parental-control/users/${user.userId}`)
              }
            >
              <Row align="middle">
                <Col flex="auto" style={styles.titleContainer}>
                  <Text style={styles.textName}>{user.username}</Text>
                  <Text style={styles.textSub}>{user.email}</Text>
                </Col>
                <Col>
                  <RightOutlined style={styles.iconStyles} />
                </Col>
              </Row>
            </Card>
          ))
        )}
      </div>
      <div style={styles.buttonContainer}>
        <Button
          size="large"
          style={styles.buttonPrimary}
          onClick={() => navigate("/parental-control/users/add")}
        >
          Agregar usuario
        </Button>
      </div>
    </SubDefaultLayout>
  );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
  listContainer: {
    width: "50%",
    margin: "0 auto",
    marginTop: 50,
  },
  cardStyles: {
    marginBottom: 15,
    boxShadow: "0px 0px 8px #00000029",
    borderRadius: 15,
    cursor: "pointer",
  },
  titleContainer: {
    display: "flex",
    flexDirection: "column",
  },
  textName: {
    fontWeight: "bold",
    fontSize: "1.50em",
    color: "#0055c1",
  },
  textSub: {
    fontWeight: 600,
  },
  emptyText: {
    display: "block",
    textAlign: "center",
    paddingVertical: 30,
  },
  iconStyles: {
    fontSize: 18,
    color: "#767a82",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: 30,
    marginBottom: 20
  },
  buttonPrimary: {
    backgroundColor: "#0055c2",
    borderRadius: 30,
    color: "white",
    border: "none",
    padding: "5px 40px",
  },
});

//-------------------------------------------------------------------------------------------------- Exports
export default ParentalControlUsers;
